export default __webpack_public_path__ + "static/N0148-15f6d66568cc801613153399abb90747.png";